import React from 'react'
import './RankingModal.css'

export default function RankingModal({ 
  show, 
  onClose, 
  globalRanking, 
  personalRanking, 
  currentUserId,
  gameOver 
}) {
  if (!show) return null

  return (
    <div className="ranking-modal" onClick={onClose}>
      <div className="ranking-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        
        {!gameOver && (
          <div className="ranking-paused-notice">
            ⏸️ Jogo pausado enquanto você visualiza o ranking
          </div>
        )}
        
        <div className="ranking-tabs">
          <div className="ranking-section">
            <h2>🏆 Ranking Global</h2>
            <div className="ranking-list">
              {globalRanking.map((entry, index) => (
                <div 
                  key={entry.id} 
                  className={`ranking-item ${entry.userId === currentUserId ? 'highlight' : ''}`}
                >
                  <span className="rank">#{index + 1}</span>
                  {entry.userPhoto ? (
                    <img src={entry.userPhoto} alt="" className="ranking-photo" />
                  ) : (
                    <div className="ranking-photo ranking-photo-placeholder">
                      {(entry.userName || 'U').charAt(0).toUpperCase()}
                    </div>
                  )}
                  <span className="ranking-name">{entry.userName}</span>
                  <span className="ranking-score">{entry.score} pts</span>
                </div>
              ))}
              {globalRanking.length === 0 && (
                <p className="no-data">Nenhum registro ainda</p>
              )}
            </div>
          </div>
          
          <div className="ranking-section">
            <h2>👤 Ranking Pessoal</h2>
            <div className="ranking-list">
              {personalRanking.map((entry, index) => (
                <div key={entry.id} className="ranking-item">
                  <span className="rank">#{index + 1}</span>
                  <span className="ranking-info">
                    {entry.score} pts
                  </span>
                </div>
              ))}
              {personalRanking.length === 0 && (
                <p className="no-data">Jogue para criar seu histórico!</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
